import { call, all } from "redux-saga/effects";
import { createEntitySaga } from "./apiSagas.js";

import { SSH_KEYS } from "../actions/actionConstants.js";
import { OPERATIONS } from "../../constants/operations.js";

import { createSSHKey } from "../reducers/sshKeys/sshKeyActions.js";

import { operationAction } from "../reducers/operations/operationActions.js";

import { operationSaga } from "./operationSagas.js";
import { splitByRowState } from "../../utils/tableUtils.js";

// -- SSH KEYS -- //

// used in accountSagas.js
export function* sshKeySaga(action) {
  const { userId, sshKeys } = action.payload;

  const splitKeys = splitByRowState(sshKeys, "sshKeys");

  let calls = {};

  for (let i = 0; i < splitKeys.new.length; i++) {
    const sshKey = splitKeys.new[i];
    calls[sshKey.fieldPath] = call(
      createEntitySaga,
      SSH_KEYS,
      undefined,
      createSSHKey(userId, sshKey)
    );
  }

  for (let i = 0; i < splitKeys.deleted.length; i++) {
    const sshKey = splitKeys.deleted[i];

    calls[sshKey.fieldPath] = operationSaga(
      operationAction(SSH_KEYS, sshKey, OPERATIONS.DELETE)
    );
  }

  let result = yield all(calls);

  // as we already have the data for existing sskKeys just append it to the return
  for (let i = 0; i < splitKeys.existing.length; i++) {
    const sshKey = splitKeys.existing[i];
    result[sshKey.fieldPath] = sshKey;
  }

  return result;
}
